import { useDispatch, useStore } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { useUpdateUserMeetingIntelligenceDataMutation } from '../api'
import {
  closeLoadingModal,
  showAcknowledgementLoadingModal,
  setAcknowledgementRedirectDestination
} from '../components/wizard_modal_loader/wizard_modal_loader_slice'
import { USER_HAS_MEETING_ROUTE, MI_MEETINGS_TOUR } from '../constants'

/**
 * Shows a loader while enabling notetaker, giving time for the async tracking job to start.
 * Redirects to the meetings page with the tour parameter when complete.
 * Uses the existing WizardAcknowledgementModal component to render the loader.
 */
export const useEnableNotetakerWithLoader = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const store = useStore()
  const [updateMiEnabled] = useUpdateUserMeetingIntelligenceDataMutation()

  const enableNotetaker = async () => {
    const meetingsRedirect = `${USER_HAS_MEETING_ROUTE}?${MI_MEETINGS_TOUR.STEP_ONE}=true`
    dispatch(setAcknowledgementRedirectDestination(meetingsRedirect))
    dispatch(showAcknowledgementLoadingModal())
    try {
      await updateMiEnabled({ miEnabled: true }).unwrap()
    } catch {
      const state = store.getState()
      const isLoaderStillShowing = state?.meetingIntelligence?.loadingModal?.showAcknowledgementLoadingModal ?? false

      if (isLoaderStillShowing) {
        dispatch(closeLoadingModal())
        history.push('/app/personal/ai_notetaker')
      }
    }
  }

  return enableNotetaker
}
